export default __webpack_public_path__ + "static/media/PlaynGO.2fd650c2.png";